import React from "react";
import ReactDOM from "react-dom";
import mapboxgl from "mapbox-gl";
import { UserPictureCache } from "Hooks";
import { ActivityReservationInternalModel } from "Services/API/API";
import { ActivityProperties } from "./types";
import ClusterMarker from "./ClusterMarker";
import ActivityMarker from "./ActivityMarker";

export const getFeatureCollectionFromActivities = (
   activities: ActivityReservationInternalModel[]
): GeoJSON.FeatureCollection<GeoJSON.Point, ActivityProperties> => {
   const features = activities.map(
      (activity): GeoJSON.Feature<GeoJSON.Point, ActivityProperties> => ({
         type: "Feature",
         properties: {
            memberId: activity.memberId,
            memberFullName: activity.memberFullName,
            memberEmail: activity.memberEmail,
            reservationId: activity.reservationId,
         },
         geometry: {
            type: "Point",
            coordinates: [activity.longitude, activity.latitude],
         },
      })
   );

   return {
      type: "FeatureCollection",
      features,
   };
};

export const clusterClick = (
   map: mapboxgl.Map,
   source: mapboxgl.GeoJSONSource,
   clusterId: number,
   lngLat: mapboxgl.LngLat
) => {
   source.getClusterExpansionZoom(clusterId, (err, zoom) => {
      if (err) return;
      map.easeTo({
         center: lngLat,
         zoom: zoom,
      });
   });
};

export const createClusterElement = (
   container: HTMLDivElement,
   features: GeoJSON.Feature<GeoJSON.Point, ActivityProperties>[],
   pictureCache: UserPictureCache
) => {
   const count = features.length;
   const firstActivities = features
      .slice(0, 2)
      .map((feature) => feature.properties);

   ReactDOM.render(
      <ClusterMarker count={ count } activities = { firstActivities } pictureCache = { pictureCache } />,
      container
   );
};

export const createActivityElement = (
   container: HTMLDivElement,
   activity: ActivityProperties,
   pictureCache: UserPictureCache
) => {
   ReactDOM.render(<ActivityMarker activity={ activity } pictureCache = { pictureCache } />, container);
};

export const getRandomInt = (max: number): number => {
   return Math.floor(Math.random() * max);
 }